import { SERVICES } from "@/data/services";
import { KEYWORDS_BY_SLUG } from "@/data/seoKeywords";
import { getStateBySlug, getCountyInState, getMetroBySlug } from "@/data/usLocations";
import { DISCIPLINES, getDiscipline } from "@/data/disciplines";

const STATIC_TARGETS = {
  "/": { keyword: "outsourced CAD drafting for land surveyors", page_type: "home" },
  "/services": { keyword: "land survey CAD drafting services", page_type: "hub" },
  "/survey-techies": { keyword: "survey CAD technician outsourcing", page_type: "hub" },
  "/cad-techies": { keyword: "outsourced CAD drafting services", page_type: "hub" },
  "/cad-services": { keyword: "CAD drafting services USA", page_type: "location" },
  "/disciplines": { keyword: "CAD and BIM drafting services", page_type: "hub" },
  "/blog": { keyword: "CAD drafting guides", page_type: "blog" },
  "/about": { keyword: "CAD drafting company", page_type: "company" },
  "/contact": { keyword: "CAD drafting quote", page_type: "contact" },
};

/** Map a route to the target keyword it was built to rank for (blog posts resolve server-side). */
export function resolveTarget(pathname) {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (STATIC_TARGETS[path]) return STATIC_TARGETS[path];
  const [, a, b, c] = path.split("/");
  if (a === "services" && b) return { keyword: KEYWORDS_BY_SLUG[b]?.[0] || null, page_type: "service" };
  if (a === "disciplines" && b) return { keyword: getDiscipline(b)?.primaryKeyword || null, page_type: "discipline" };
  if (a === "blog" && b) return { keyword: null, page_type: "blog-post" };
  if (a === "metros" && b) {
    const m = getMetroBySlug(b);
    return { keyword: m ? `${m.name} CAD drafting services` : null, page_type: "metro" };
  }
  if (a === "cad-services" && b) {
    const st = getStateBySlug(b);
    if (!st) return { keyword: null, page_type: "location" };
    if (c) {
      const co = getCountyInState(st, c);
      return { keyword: co ? `${co.name} ${st.abbr} survey drafting` : null, page_type: "county" };
    }
    return { keyword: `${st.state} survey CAD drafting`, page_type: "state" };
  }
  return { keyword: null, page_type: "other" };
}

/** Core target keywords always listed in the admin tracker, even with zero visits. */
export const CORE_TARGETS = [
  ...Object.entries(STATIC_TARGETS).map(([path, t]) => ({ ...t, path })),
  ...SERVICES.map((s) => ({ keyword: KEYWORDS_BY_SLUG[s.slug]?.[0], page_type: "service", path: `/services/${s.slug}` })),
  ...DISCIPLINES.map((d) => ({ keyword: d.primaryKeyword, page_type: "discipline", path: `/disciplines/${d.slug}` })),
].filter((t) => t.keyword);
